<script lang="ts">
  import Link from "svelte-link";
  import { Button, Card, CardBody, Col, Image } from "sveltestrap";
  import { Applyforthisjob, EndlessUnitedStates, ProductDesigner, href } from "../../../../utils/Constant/Constant";
  import SimilarJobs from "./SimilarJobs.svelte";
  import CardRating from "../CardsView/CardRating.svelte";
  import JobDescriptionBody from "./JobDescriptionBody.svelte";
  let imgPath:string = "/assets/images/job-search"

</script>
<Col xl="9" class="xl-60 box-col-8">
  <Card>
    <div class="job-search">
      <CardBody>
        <div class="media">
          <Image fluid class="img-40 m-r-20" src="{imgPath}/1.jpg" alt="" />
          <div class="media-body">
            <h6 class="f-w-600">
              <Link href={href}>{ProductDesigner}</Link>
            </h6>
            <p>{EndlessUnitedStates}</p>
            <CardRating />
            <Button color="primary" size="sm" class="job-apply-btn" href={href}>{Applyforthisjob}</Button>
          </div>
        </div>
        <JobDescriptionBody />
      </CardBody>
    </div>
  </Card>
  <SimilarJobs />
</Col>